// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-menu__content[data-v-b7c64a3e]{max-height:unset!important}", ""]);
// Exports
module.exports = exports;
